/* Maharaja Super — free shipping progress bar.
   The bar is rendered in Liquid (snippets/mx-shipping-bar.liquid). After the
   cart changes, every bar fetches a fresh copy from /?sections=mx-shipping-bar. Every bar animates its
   fill from where the previous one stood, and pulses a stage when it unlocks. */
(function () {
  if (customElements.get('mx-ship-bar')) return;

  const state = window.__mxShip || (window.__mxShip = { pct: null, reached: null });
  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Stage labels are absolutely positioned, so reserve room for the tallest one.
  function fitLabels(inner) {
    const wrap = inner.querySelector('.mx-ship__track-wrap');
    const labels = inner.querySelectorAll('.mx-ship__label');
    if (!wrap || !labels.length) return;
    const trackBottom = wrap.querySelector('.mx-ship__track').getBoundingClientRect().bottom;
    let bottom = 0;
    labels.forEach((label) => {
      bottom = Math.max(bottom, label.getBoundingClientRect().bottom);
    });
    if (!bottom || !wrap.offsetWidth) return;
    wrap.style.paddingBottom = Math.ceil(bottom - trackBottom + 4) + 'px';
  }

  window.addEventListener('resize', () => {
    document.querySelectorAll('.mx-ship__inner').forEach(fitLabels);
  });

  function animate(inner, fromPct, fromReached) {
    fitLabels(inner);
    const fill = inner.querySelector('.mx-ship__fill');
    const to = parseFloat(inner.dataset.pct) || 0;
    const reached = parseInt(inner.dataset.reached, 10) || 0;

    if (fill && fromPct !== null && fromPct !== to && !reduced) {
      fill.style.transition = 'none';
      fill.style.width = fromPct + '%';
      void fill.offsetWidth;
      fill.style.transition = '';
      requestAnimationFrame(() => (fill.style.width = to + '%'));
    }

    if (fromReached !== null && reached > fromReached) {
      const stages = inner.querySelectorAll('.mx-ship__stage');
      for (let i = fromReached; i < reached && i < stages.length; i++) {
        stages[i].classList.add('just-unlocked');
      }
      inner.classList.add('just-unlocked');
    }

    state.pct = to;
    state.reached = reached;
  }

  class MxShipBar extends HTMLElement {
    connectedCallback() {
      const inner = this.querySelector('.mx-ship__inner');
      const inDrawer = !!this.closest('cart-drawer');
      // Drawer bars continue from the last known position; page bars grow in from 0 on load.
      if (inner) animate(inner, inDrawer ? state.pct : 0, inDrawer ? state.reached : null);
      if (inner && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          const current = this.querySelector('.mx-ship__inner');
          if (current) fitLabels(current);
        });
        this.resizeObserver.observe(this);
      }

      // Every bar (drawer included) refreshes after any cart change, so it always
      // matches the real cart even when the theme skips its own drawer refresh.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => MxShipBar.refreshAll());
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    static refreshAll() {
      clearTimeout(MxShipBar.timer);
      MxShipBar.timer = setTimeout(async () => {
        const bars = Array.from(document.querySelectorAll('mx-ship-bar'));
        if (!bars.length) return;
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(root + '?sections=mx-shipping-bar', { credentials: 'same-origin' });
          const json = await response.json();
          const doc = new DOMParser().parseFromString(json['mx-shipping-bar'] || '', 'text/html');
          const fresh = doc.querySelector('.mx-ship__inner');
          if (!fresh) return;
          bars.forEach((bar) => {
            const old = bar.querySelector('.mx-ship__inner');
            const fromPct = old ? parseFloat(old.dataset.pct) || 0 : null;
            const fromReached = old ? parseInt(old.dataset.reached, 10) || 0 : null;
            const copy = fresh.cloneNode(true);
            if (old) old.replaceWith(copy);
            else bar.appendChild(copy);
            animate(copy, fromPct, fromReached);
          });
        } catch (error) {
          console.error('Free shipping bar:', error);
        }
      }, 250);
    }
  }

  customElements.define('mx-ship-bar', MxShipBar);
})();
